import { useNavigate } from "react-router";
import { CompassIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/EmptyState";

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-svh items-center justify-center bg-background px-4">
      <EmptyState
        icon={CompassIcon}
        title="Page not found"
        description="The page you're looking for doesn't exist or may have been moved."
        action={<Button onClick={() => navigate("/dashboard")}>Go to dashboard</Button>}
      />
    </div>
  );
}
